import React, { PureComponent } from 'react';

interface Props {
    size?: number;
}

class ThreedoteSVG extends PureComponent<Props> {

    render() {
        const { size } = this.props;
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="0.25rem" height="1rem" viewBox="0 0 4 16" preserveAspectRatio="xMidYMid" style={{ fontSize: `${size}rem` }}  >
            <path d="M4 2C4 3.10457 3.10457 4 2 4C0.895431 4 0 3.10457 0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2Z" fill="currentColor"/>
            <path d="M4 8C4 9.10457 3.10457 10 2 10C0.895431 10 0 9.10457 0 8C0 6.89543 0.895431 6 2 6C3.10457 6 4 6.89543 4 8Z" fill="currentColor"/>
            <path d="M4 14C4 15.1046 3.10457 16 2 16C0.895431 16 0 15.1046 0 14C0 12.8954 0.895431 12 2 12C3.10457 12 4 12.8954 4 14Z" fill="currentColor"/>
            </svg>
        );
    }
}

export default ThreedoteSVG;